import { styled } from 'styled-components';

interface LabelProps {
    text: string;
};

const LabelWrapper = styled.div`
    background-color: #FFFFFF;
    color: #5199E0;
    font-size: 18px;
    font-weight: 500;
    border-radius: 100px;
    padding: 8px 16px;
    line-height: 28px;
`;

const Label = ({ text }: LabelProps) => <LabelWrapper>{text}</LabelWrapper>;

export default Label;
